<template>
<div>
  <Promote v-if="promoter == 'Y'"></Promote>
  <!-- 不是推广员:申请被拒绝、正在审核 -->
  <PromoteStatus v-else-if="promoter == 'N' && companies&&companies.status == 1000" ></PromoteStatus>
  <PromoteStatus v-else-if="promoter == 'N' && companies&&companies.status == 1006" ></PromoteStatus>
  <!-- 不是推广员:未申请 -->
  <!-- <PromoteRule v-else-if="promoter == 'N'&& companies == null"></PromoteRule> -->
  <PromoteRule v-else-if="promoter == 'N'"></PromoteRule>
</div>

</template>

<script>
import Promote from "./promote.vue";
import PromoteRule from "./promoteRule.vue";
import PromoteStatus from "./promoteStatus.vue";


export default {
  name: "promotion",
  data() {
    return {
      promoter: "",
      companies: "",
    };
  },
  components: {
    Promote,
    PromoteRule,
    PromoteStatus,
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/queryByCustdistribution",
        {}
      ).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            this.promoter = res.data.promoter;
            this.companies = res.data.companies;
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
  },
};
</script>

<style>
</style>